import { DialogService } from "@progress/kendo-angular-dialog";
import { LaboratoriesService } from "../../../services/laboratories.service";
import { RequestWaterSamplingsService } from "../../../services/request-water-samplings.service";
import { WizardBaseComponent } from "../../wizard-base/wizard-base.component";
import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { RequestWaterSamplingAct } from "../../../models/request/request-water-sampling/request-water-sampling-act";
import { LaboratoryRequestIndicatorDto } from "../../../models/laboratory/laboratory-request-indicator.dto";
import { RequestWaterSamplingActsService } from "../../../services/request-water-sampling-acts.service";
import { forkJoin } from "rxjs";
import { LaboratoryCertificateRequiringDto } from "../../../models/laboratory/laboratory-certificate-requirings.dto";
import { LaboratoryExaminationObjectDto } from "../../../models/laboratory/laboratory-examination-objects.dto";
import { LaboratoryExaminationTargetDto } from "../../../models/laboratory/laboratory-examination-targets.dto";
import { LaboratoryExaminationTypeDto } from "../../../models/laboratory/laboratory-examination-types.dto";
import { LaboratoryMaterialSourceDto } from "../../../models/laboratory/laboratory-material-sources.dto";
import { LaboratoryRecommendationDto } from "../../../models/laboratory/laboratoy-recommendations.dto";
import { LaboratoryResultDeliveryTypeDto } from "../../../models/laboratory/laboratory-result-delivery-types.dto";
import { LaboratorySamplingPointDto } from "../../../models/laboratory/laboratory-sampling-points.dto";
import { LaboratoryExaminationTypeIndicatorDto } from "../../../models/laboratory/laboratory-examination-type-indicator.dto";
import { LaboratoryIndicatorDto } from "../../../models/laboratory/laboratory-indicator.dto";
import { LaboratorySamplingPerformerDto } from "../../../models/laboratory/laboratory-sampling-performer.dto";
import { LaboratorySampleDeliveryPerformerDto } from "../../../models/laboratory/laboratory-sample-delivery-performer.dto";
import { LaboratorySampleLeftoverActionDto } from "../../../models/laboratory/laboratory-sample-leftover-action.dto";
import { LaboratorySampleContainerVisualDamageDto } from "../../../models/laboratory/laboratory-sample-container-visual-damage.dto";
import { LaboratorySampleContainerRequirementDto } from "../../../models/laboratory/laboratory-sample-container-requirement.dto";
import { LaboratoryDeliveryTimeRequirementDto } from "../../../models/laboratory/laboratory-delivery-time-requirement.dto";
import { LaboratorySampleContainerTypeDto } from "../../../models/laboratory/laboratory-sample-container-type.dto";
import { LaboratorySamplePreserveDto } from "../../../models/laboratory/laboratory-sample-preserve.dto";
import { StepperItem } from "../../stepper/app-stepper.component";
import { WizardStepComponent } from "../../../../core/interfaces/wizard-step-component";
import { CheckboxItem, CheckboxSelectorComponent } from "../../checkbox-selector/checkbox-selector.component";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { RequestWaterSamplingContact } from "../../../models/request/request-water-sampling/request-water-sampling-contact";
import { RequestWaterSamplingAddress } from "../../../models/request/request-water-sampling/request-water-sampling-address";
import { LaboratorySpecialMarkDto } from "../../../models/laboratory/laboratory-special-mark.dto";
import { AppService } from "../../../../app.service";
import { ContragentsService } from "../../../../categories/contragents/contragents.service";
import { CustomerObjectsService } from "../../../../categories/customer-objects/customer-objects.service";
import { ActionDataResult } from "../../../models/core/ActionDataResult";
import { ActivitiesService } from "../../../services/activities.service";
import { ActivityType } from "../../../enums/activity-type.enum";
import { ContragentWithContactDto } from "../../../models/contragent/contragent-with-contact-dto";
import { CustomerObjectWithContactsDto } from "../../../models/customerObject/customer-object-with-contacts.dto";
import { Activity } from "../../../models/activity/activity";
import { LaboratoryWaterSamplingConditionDto } from "../../../models/laboratory/laboratory-water-sampling-condition.dto";
import { LaboratoryWaterSamplingMethodDto } from "../../../models/laboratory/laboratory-water-sampling-method.dto";
import { LaboratoryWaterSamplingRegulatoryDocumentDto } from "../../../models/laboratory/laboratory-water-sampling-regulatory-document.dto";
import { RequestCategoryEnum } from "../../../enums/request-category.enum";
import { DropdownListCountryPhoneMasksComponent } from "../../dropdownlist-country-phone-masks/dropdownlist-country-phone-masks.component";

@Component({
    selector: 'create-request-water-sampling-act',
    templateUrl: './create-request-water-sampling-act.component.html',
    styleUrls: ['./create-request-water-sampling-act.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss']
})
export class CreateRequestWaterSamplingActComponent extends WizardBaseComponent {
    
    @ViewChild("firstStep") firstStepComponent: WizardStepComponent;
    @ViewChild("countryPhoneMasksComponent") countryPhoneMasksComponent: DropdownListCountryPhoneMasksComponent;

    @Input() requestId: number;
    @Input() requestCategoryId: number;
    @Input() contragentId: number;
    @Input() customerObjectId: number;
    @Input() contentHeight: number = 640;

    cellPhoneMask: string = "+7 (000) 000-00-00";
	public rules: { [key: string]: RegExp } = {
		'0': /\d/
	};

    private otherCode: string = 'other';
    private bottleCode: string = 'bottle';
    private detectedCode: string = 'detected';
    private violateCode: string = 'violate';
    private manualPreserveCode: string = 'manual_preserve';
    private contragentCode: string = 'contragent';
    private barierCode: string = 'barier';

    contragent: ContragentWithContactDto;
    customerObject: CustomerObjectWithContactsDto;
    laboratoryActivity: Activity;

    requestWaterSamplingAct: RequestWaterSamplingAct = null;
    requestIndicators: LaboratoryRequestIndicatorDto[] = [];

    dataSaving: boolean;
    private actLoaded: boolean;
    private lookupsLoaded: boolean;
    showWaterTapPreRinsing: boolean;

    certificateRequirings: LaboratoryCertificateRequiringDto[] = [];
    examinationObjects: LaboratoryExaminationObjectDto[] = [];
    examinationTargets: LaboratoryExaminationTargetDto[] = [];
    examinationTypes: LaboratoryExaminationTypeDto[] = [];
    materialSources: LaboratoryMaterialSourceDto[] = [];
    recommendations: LaboratoryRecommendationDto[] = [];
    resultDeliveryTypes: LaboratoryResultDeliveryTypeDto[] = [];
    samplingPoints: LaboratorySamplingPointDto[] = [];
    examinationTypeIndicators: LaboratoryExaminationTypeIndicatorDto[] = [];
    indicators: LaboratoryIndicatorDto[] = [];
    samplingPerformers: LaboratorySamplingPerformerDto[] = [];
    sampleDeliveryPerformers: LaboratorySampleDeliveryPerformerDto[] = [];
    sampleLeftoverActions: LaboratorySampleLeftoverActionDto[] = [];
    sampleContainerVisualDamages: LaboratorySampleContainerVisualDamageDto[] = [];
    sampleContainerRequirements: LaboratorySampleContainerRequirementDto[] = [];
    deliveryTimeRequirements: LaboratoryDeliveryTimeRequirementDto[] = [];
    sampleContainerTypes: LaboratorySampleContainerTypeDto[] = [];
    samplePreserves: LaboratorySamplePreserveDto[] = [];
    specialMarks: LaboratorySpecialMarkDto[] = [];
    samplingConditions: LaboratoryWaterSamplingConditionDto[] = [];
    samplingMethods: LaboratoryWaterSamplingMethodDto[] = [];
    regulatoryDocuments: LaboratoryWaterSamplingRegulatoryDocumentDto[] = [];

    constructor(
        private laboratoriesService: LaboratoriesService,
        private requestWaterSamplingActsService: RequestWaterSamplingActsService,
        private contragentsService: ContragentsService,
        private customerObjectsService: CustomerObjectsService,
        private activitiesService: ActivitiesService,
        private dialogService: DialogService,
        private appService: AppService
    ) { 
        super();
    }

    initData() {
        this.requestWaterSamplingAct = new RequestWaterSamplingAct();

        this.requestWaterSamplingActsService.getByRequest(this.requestId).subscribe(resp => {
            if (resp == null) {
                this.requestWaterSamplingActsService.createByRequestWaterSampling(this.requestId).subscribe(() => {
                    this.requestWaterSamplingActsService.getByRequest(this.requestId).subscribe(newResp => {
                        this.requestWaterSamplingAct = newResp;
                        this.normalizeRegulatoryDocumentIds();
                        this.requestIndicators = newResp.requestIndicators;
                        this.showWaterTapPreRinsing = newResp.waterTapPreRinsing != null;
                        this.loadCustomerData();
                        this.fillActContactsAndAddresses();
                        this.refreshMask();
                        this.actLoaded = true;
                    });
                });
            }
            else {
                this.requestWaterSamplingAct = resp;
                this.normalizeRegulatoryDocumentIds();
                this.requestIndicators = resp.requestIndicators;
                this.showWaterTapPreRinsing = resp.waterTapPreRinsing != null;
                this.loadCustomerData();
                this.fillActContactsAndAddresses();
                this.refreshMask();
                this.actLoaded = true;
            }

            this.buildSteps();

            const certificateRequirings$ = this.laboratoriesService.getAllCertificateRequirings();
            const examinationObjects$ = this.laboratoriesService.getAllExaminationObjects();
            const examinationTargets$ = this.laboratoriesService.getAllExaminationTargets();
            const examinationTypes$ = this.laboratoriesService.getAllExaminationTypes();
            const materialSources$ = this.laboratoriesService.getAllMaterialSources();
            const recommendations$ = this.laboratoriesService.getAllRecommendations();
            const resultDeliveryTypes$ = this.laboratoriesService.getAllResultDeliveryTypes();
            const samplingPoints$ = this.laboratoriesService.getAllSamplingPoints();
            const examinationTypeIndicators$ = this.laboratoriesService.getAllExaminationTypeIndicators();
            const indicators$ = this.laboratoriesService.getAllIndicators();
            const samplingPerformers$ = this.laboratoriesService.getAllSamplingPerformers();
            const sampleDeliveryPerformers$ = this.laboratoriesService.getAllSampleDeliveryPerformers();
            const sampleLeftoverActions$ = this.laboratoriesService.getAllSampleLeftoverActions();
            const sampleContainerVisualDamages$ = this.laboratoriesService.getAllSampleContainerVisualDamages();
            const sampleContainerRequirements$ = this.laboratoriesService.getAllSampleContainerRequirements();
            const deliveryTimeRequirements$ = this.laboratoriesService.getAllDeliveryTimeRequirements();
            const sampleContainerTypes$ = this.laboratoriesService.getAllSampleContainerTypes();
            const samplePreserves$ = this.laboratoriesService.getAllSamplePreserves();
            const specialMarks$ = this.laboratoriesService.getAllSpecialMarks();
            const samplingConditions$ = this.laboratoriesService.getAllLaboratoryWaterSamplingConditions();
            const samplingMethods$ = this.laboratoriesService.getAllLaboratoryWaterSamplingMethods();
            const regulatoryDocuments$ = this.laboratoriesService.getAllLaboratoryWaterSamplingRegulatoryDocuments();
    
            forkJoin(
                certificateRequirings$, 
                examinationObjects$, 
                examinationTargets$,
                examinationTypes$,
                materialSources$,
                recommendations$,
                resultDeliveryTypes$,
                samplingPoints$,
                examinationTypeIndicators$,
                indicators$,
                samplingPerformers$,
                sampleDeliveryPerformers$,
                sampleLeftoverActions$,
                sampleContainerVisualDamages$,
                sampleContainerRequirements$,
                deliveryTimeRequirements$,
                sampleContainerTypes$,
                samplePreserves$,
                specialMarks$,
                samplingConditions$,
                samplingMethods$,
                regulatoryDocuments$
            ).subscribe(([
                certificateRequirings, 
                examinationObjects, 
                examinationTargets,
                examinationTypes,
                materialSources,
                recommendations,
                resultDeliveryTypes,
                samplingPoints,
                examinationTypeIndicators,
                indicators,
                samplingPerformers,
                sampleDeliveryPerformers,
                sampleLeftoverActions,
                sampleContainerVisualDamages,
                sampleContainerRequirements,
                deliveryTimeRequirements,
                sampleContainerTypes,
                samplePreserves,
                specialMarks,
                samplingConditions,
                samplingMethods,
                regulatoryDocuments
            ]) => {
                this.certificateRequirings = certificateRequirings.data;
                this.examinationObjects = examinationObjects.data;
                this.examinationTargets = examinationTargets.data;
                this.examinationTypes = examinationTypes.data;
                this.materialSources = materialSources.data;
                this.recommendations = recommendations.data;
                this.resultDeliveryTypes = resultDeliveryTypes.data;
                this.samplingPoints = samplingPoints.data;
                this.examinationTypeIndicators = examinationTypeIndicators.data;
                this.indicators = indicators.data;
                this.samplingPerformers = samplingPerformers.data;
                this.sampleDeliveryPerformers = sampleDeliveryPerformers.data;
                this.sampleLeftoverActions = sampleLeftoverActions.data;
                this.sampleContainerVisualDamages = sampleContainerVisualDamages.data;
                this.sampleContainerRequirements = sampleContainerRequirements.data;
                this.deliveryTimeRequirements = deliveryTimeRequirements.data;
                this.sampleContainerTypes = sampleContainerTypes.data;
                this.samplePreserves = samplePreserves.data;
                this.specialMarks = specialMarks.data;
                this.samplingConditions = samplingConditions.data;
                this.samplingMethods = samplingMethods.data;
                this.regulatoryDocuments = regulatoryDocuments.data;
    
                this.refreshStepStatuses();
                this.refreshMask();
                this.lookupsLoaded = true;
            });
        });
    }

    loadCustomerData() {
        const customerObject$ = this.customerObjectsService.getCustomerObjectWithContacts(this.customerObjectId);
        const contragent$ = this.contragentsService.getContragentWithContact(this.contragentId);
        const laboratoryActivity$ = this.activitiesService.getLastActivityByType(this.requestId, <number>ActivityType.waterSampling);

        forkJoin(customerObject$, contragent$, laboratoryActivity$)
        .subscribe(([customerObject, contragent, laboratoryActivity]) => {
            this.contragent = contragent;
            this.customerObject = customerObject;
            this.laboratoryActivity = laboratoryActivity;

            if (this.isEmpty(this.requestWaterSamplingAct.customerAddress.cityName) && contragent.addressInfo) {
                this.requestWaterSamplingAct.customerAddress.cityName = contragent.addressInfo.cityName;
            }
            if (this.isEmpty(this.requestWaterSamplingAct.customerAddress.street) && contragent.addressInfo) {
                this.requestWaterSamplingAct.customerAddress.street = contragent.addressInfo.street;
            }
            if (this.isEmpty(this.requestWaterSamplingAct.customerAddress.house) && contragent.addressInfo) {
                this.requestWaterSamplingAct.customerAddress.house = contragent.addressInfo.house;
            }
            if (this.isEmpty(this.requestWaterSamplingAct.customerAddress.appartment) && contragent.addressDescription) {
                this.requestWaterSamplingAct.customerAddress.appartment = contragent.addressDescription;
            }

            if (this.isEmpty(this.requestWaterSamplingAct.samplingAddress.cityName) && customerObject.addressInfo) {
                this.requestWaterSamplingAct.samplingAddress.cityName = customerObject.addressInfo.cityName;
            }
            if (this.isEmpty(this.requestWaterSamplingAct.samplingAddress.street) && customerObject.addressInfo) {
                this.requestWaterSamplingAct.samplingAddress.street = customerObject.addressInfo.street;
            }
            if (this.isEmpty(this.requestWaterSamplingAct.samplingAddress.house) && customerObject.addressInfo) {
                this.requestWaterSamplingAct.samplingAddress.house = customerObject.addressInfo.house;
            }
            if (this.isEmpty(this.requestWaterSamplingAct.samplingAddress.appartment) && customerObject.addressDescription) {
                this.requestWaterSamplingAct.samplingAddress.appartment = customerObject.addressDescription;
            }

            if (this.isEmpty(this.requestWaterSamplingAct.customerContact.fullName)) {
                this.requestWaterSamplingAct.customerContact.fullName = contragent.isIndividual
                    ? contragent.contactFullName
                    : contragent.name;
            }
            if (this.isEmpty(this.requestWaterSamplingAct.customerContact.phone)) {
                this.requestWaterSamplingAct.customerContact.phone = contragent.contactPhone;
            }
            if (this.isEmpty(this.requestWaterSamplingAct.customerContact.email)) {
                this.requestWaterSamplingAct.customerContact.email = contragent.contactEmail;
            }

            this.requestWaterSamplingAct.laboratorySamplingPerformerDateTimeStart = this.requestWaterSamplingAct.laboratorySamplingPerformerDateTimeStart != null
                ? this.appService.parseDateTime(this.requestWaterSamplingAct.laboratorySamplingPerformerDateTimeStart)
                : null;

            this.requestWaterSamplingAct.laboratorySamplingPerformerDateTimeEnd = this.requestWaterSamplingAct.laboratorySamplingPerformerDateTimeEnd != null
                ? this.appService.parseDateTime(this.requestWaterSamplingAct.laboratorySamplingPerformerDateTimeEnd)
                : null;

            this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerDateTime = this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerDateTime != null
                ? this.appService.parseDateTime(this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerDateTime)
                : new Date();

            if (this.samplingPerformerIsContragent && this.requestWaterSamplingAct.customerContact.fullName) {
                this.requestWaterSamplingAct.laboratorySamplingPerformerName = this.requestWaterSamplingAct.customerContact.fullName;
            }
            else if (this.samplingPerformerIsBarier && laboratoryActivity) {
                this.requestWaterSamplingAct.laboratorySamplingPerformerName = laboratoryActivity.performerUserName;
            }

            if (this.sampleDeliveryPerformerIsContragent && this.requestWaterSamplingAct.customerContact.fullName) {
                this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerName = this.requestWaterSamplingAct.customerContact.fullName;
            }
            else if (this.sampleDeliveryPerformerIsBarier && laboratoryActivity) {
                this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerName = laboratoryActivity.performerUserName;
            }
        });

        this.contragentsService.getContragentWithContact(this.contragentId).subscribe((resp) => {
            if (this.isEmpty(this.requestWaterSamplingAct.customerContact.fullName)) {
                this.requestWaterSamplingAct.customerContact.fullName = resp.isIndividual
                    ? resp.contactFullName
                    : resp.name;
            }
            if (this.isEmpty(this.requestWaterSamplingAct.customerContact.phone)) {
                this.requestWaterSamplingAct.customerContact.phone = resp.contactPhone;
            }
        });
    }

    fillActContactsAndAddresses() {
        if (this.requestWaterSamplingAct.customerContact == null) {
            this.requestWaterSamplingAct.customerContact = new RequestWaterSamplingContact();
        }

        if (this.requestWaterSamplingAct.customerAddress == null) {
            this.requestWaterSamplingAct.customerAddress = new RequestWaterSamplingAddress();
        }
        if (this.requestWaterSamplingAct.samplingAddress == null) {
            this.requestWaterSamplingAct.samplingAddress = new RequestWaterSamplingAddress();
        }
    }

    buildSteps() {
        let steps = [
            {
                id: 'step1',
                name: 'Заказчик и адрес отбора проб',
                checkSuccess: () => { return this.clientInfoValid }
            },
            { 
                id: 'step2',
                name: 'Источник, точка сбора, особые отметки и объект испытаний', 
                checkSuccess: () => { return this.examinationObjectValid && 
                    this.materialSourceValid && 
                    this.samplingPointValid &&
                    this.specialMarkValid } 
            },
            {
                id: 'step3',
                name: 'План и метод отбора',
                checkSuccess: () => { return this.samplingMethodValid && 
                    this.samplingConditionValid &&
                    this.regulatoryDocumentValid; }
            },
            { 
                id: 'step4',
                name: 'Тип анализа, определяемые показатели', 
                checkSuccess: () => { return this.indicatorsValid } 
            },
            { 
                id: 'step5',
                name: 'Цель исследования, заключении о соответствии, способ получения результатов, рекомендации', 
                checkSuccess: () => { return this.examinationTargetValid && 
                    this.requestWaterSamplingAct.laboratoryCertificateRequiringId != null &&
                    this.requestWaterSamplingAct.laboratoryResultDeliveryTypeId != null &&
                    this.requestWaterSamplingAct.laboratoryRecommendationId != null } 
            },
            { 
                id: 'step6',
                name: 'Ответственный за пробы, доставку', 
                checkSuccess: () => { return this.samplingPerformerValid &&
                    this.sampleDeliveryPerformerValid &&
                    this.sampleLeftoverActionValid } 
            },
            {
                id: 'step7',
                name: 'Визуальный осмотр, требования к посуде и срокам доставки',
                checkSuccess: () => { return this.sampleContainerVisualDamageValid &&
                    this.sampleContainerRequirementValid &&
                    this.deliveryTimeRequirementValid &&
                    this.samplePreserveValid &&
                    this.requestWaterSamplingAct.laboratorySampleContainerTypeId != null &&
                    this.requestWaterSamplingAct.laboratoryWaterSamples[0].volume != null }
            }
        ] as StepperItem[];

        // 3 шаг только для Забор проб специалистом
        if (this.requestCategoryId != <number>RequestCategoryEnum.sampleCollectionBySpecialist) {
            steps = steps.filter(x => x.id != 'step3');
        }

        for (let number = 1; number <= steps.length; number++) {
            steps[number - 1].number = number;
        }

        this.steps = steps;
    }

    goToPreviousStep() {
        if (this.currentStepNumber == 2) {
            this.refreshMask();
        }

        super.goToPreviousStep();
    }

    moveToStep(step: StepperItem) {
        if (step.number == 1) {
            this.refreshMask();
        }
        super.moveToStep(step);
    }
    
    saveStepChanges(afterAction: () => void) {
        this.saveChangesImpl(false, afterAction);
    }

    saveChanges() {
        this.saveChangesImpl(true, () => {});
    }
   
    saveChangesImpl(initChangeStatus: boolean, afterAction: () => void) {
        this.dataSaving = true;

        this.requestWaterSamplingAct.requestId = this.requestId;
        this.requestWaterSamplingAct.requestIndicators = this.requestIndicators;

        this.requestWaterSamplingActsService.update(this.requestWaterSamplingAct, null, false, true).subscribe((resp: ActionDataResult<any>) => {
            if (resp.isSuccessful) {
                if (initChangeStatus) {
                    this.onContinueEvent.emit();
                }
                afterAction();
            }
            else {
                this.toggleCurrentStep(false);
            }

            this.dataSaving = false;
        });
    }

    toggleCurrentStep(isSuccess: boolean) {
        let currentStep = this.steps.find(x => x.number == this.currentStepNumber);
        currentStep.isSuccess = isSuccess;
    }

    setMask(mask: string) {
        if (this.cellPhoneMask != mask) {
		    this.requestWaterSamplingAct.customerContact.phone = '';
        }
		this.cellPhoneMask = mask;
	}

	refreshMask() {
        setTimeout(() => {
            if (this.countryPhoneMasksComponent) {
			    this.cellPhoneMask = this.countryPhoneMasksComponent.getAndSetPhoneMask(this.requestWaterSamplingAct.customerContact.phone);
		    }
        }, 100);
    }

    changeExaminationObject() {
        if (!this.examinationObjectIsBottle) {
            this.requestWaterSamplingAct.manufactureDate = null;
            this.requestWaterSamplingAct.supplier = null;
            this.requestWaterSamplingAct.partNumber = null;
        }
        if (!this.examinationObjectIsOther) {
            this.requestWaterSamplingAct.laboratoryExaminationObjectDescription = null;
        }
    }

    changeMaterialSource() {
        if (!this.materialSourceIsOther) {
            this.requestWaterSamplingAct.laboratoryMaterialSourceDescription = null;
        }
    }

    changeSpecialMark() {
        if (!this.specialMarkIsOther) {
            this.requestWaterSamplingAct.laboratorySpecialMarkDescription = null;
        }
    }

    changeSamplingPoint() {
        if (!this.samplingPointIsOther) {
            this.requestWaterSamplingAct.laboratorySamplingPointDescription = null;
        }
    }

    changeSamplingMethod() {
        if (this.samplingMethodIsOther) {
            this.requestWaterSamplingAct.laboratoryWaterSamplingMethodDescription = null;
        }
    }

    normalizeRegulatoryDocumentIds() {
        const act = this.requestWaterSamplingAct;
        if (!act) {
            return;
        }
        const regulatoryIds = act.laboratoryWaterSamplingRegulatoryDocumentIds;
        const hasNoRegulatoryIds = regulatoryIds == null || regulatoryIds.length === 0;
        if (hasNoRegulatoryIds && act.laboratoryWaterSamplingRegulatoryDocumentId) {
            act.laboratoryWaterSamplingRegulatoryDocumentIds = [act.laboratoryWaterSamplingRegulatoryDocumentId];
        }
        if (act.laboratoryWaterSamplingRegulatoryDocumentIds == null) {
            act.laboratoryWaterSamplingRegulatoryDocumentIds = [];
        }
    }

    isRegulatoryDocumentSelected(documentId: number): boolean {
        let regulatoryIds = this.requestWaterSamplingAct.laboratoryWaterSamplingRegulatoryDocumentIds;
        if (regulatoryIds == null) {
            regulatoryIds = [];
        }
        return regulatoryIds.some(x => x === documentId);
    }

    toggleRegulatoryDocumentById(documentId: number) {
        let sourceIds = this.requestWaterSamplingAct.laboratoryWaterSamplingRegulatoryDocumentIds;
        if (sourceIds == null) {
            sourceIds = [];
        }
        let ids = sourceIds.slice();
        const idx = ids.indexOf(documentId);
        if (idx >= 0) {
            ids.splice(idx, 1);
        } else {
            ids.push(documentId);
        }
        this.requestWaterSamplingAct.laboratoryWaterSamplingRegulatoryDocumentIds = ids;
        if (!this.regulatoryDocumentIsOther) {
            this.requestWaterSamplingAct.laboratoryWaterSamplingRegulatoryDocumentDescription = null;
        }
    }

    changeSamplingCondition() {
        if (this.samplingConditionIsOther) {
            this.requestWaterSamplingAct.laboratoryWaterSamplingConditionDescription = null;
        }
    }

    changeShowWaterTapPreRinsing(event: any) {
        if (!event.target.checked) {
            this.requestWaterSamplingAct.waterTapPreRinsing = null;
        }
    }

    changeExaminationType(examinationTypeId: number) {
        let newRequestIndicators = this.examinationTypeIndicators.filter(x => 
            x.laboratoryExaminationTypeId == examinationTypeId).map(x => {
            return {
                laboratoryIndicatorId: x.laboratoryIndicatorId
            } as LaboratoryRequestIndicatorDto;
        });
        this.requestIndicators = newRequestIndicators;
    }

    changeExaminationTarget() {
        if (!this.examinationTargetIsOther) {
            this.requestWaterSamplingAct.laboratoryExaminationTargetDescription = null;
        }
    }

    changeSamplingPerformer() {
        if (!this.samplingPerformerIsOther) {
            this.requestWaterSamplingAct.laboratorySamplingPerformerDescription = null;
        }

        if (this.samplingPerformerIsContragent && this.requestWaterSamplingAct.customerContact.fullName) {
            this.requestWaterSamplingAct.laboratorySamplingPerformerName = this.requestWaterSamplingAct.customerContact.fullName;
        }
        else if (this.samplingPerformerIsBarier && this.laboratoryActivity) {
            this.requestWaterSamplingAct.laboratorySamplingPerformerName = this.laboratoryActivity.performerUserName;
        }
        else {
            this.requestWaterSamplingAct.laboratorySamplingPerformerName = null;
        }
    }

    changeSampleDeliveryPerformer() {
        if (!this.sampleDeliveryPerformerIsOther) {
            this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerDescription = null;
        }

        if (this.sampleDeliveryPerformerIsContragent && this.requestWaterSamplingAct.customerContact.fullName) {
            this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerName = this.requestWaterSamplingAct.customerContact.fullName;
        }
        else if (this.sampleDeliveryPerformerIsBarier && this.laboratoryActivity) {
            this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerName = this.laboratoryActivity.performerUserName;
        }
        else {
            this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerName = null;
        }
    }

    changeSampleLeftoverAction() {
        if (!this.sampleLeftoverActionIsOther) {
            this.requestWaterSamplingAct.laboratorySampleLeftoverActionDescription = null;
        }
    }

    changeSampleContainerVisualDamage() {
        if (!this.sampleContainerVisualDamageIsDetected) {
            this.requestWaterSamplingAct.laboratorySampleContainerVisualDamageDescription = null;
        }
    }

    changeSampleContainerRequirement() {
        if (!this.sampleContainerRequirementIsViolate) {
            this.requestWaterSamplingAct.laboratorySampleContainerRequirementDescription = null;
        }
    }

    changeDeliveryTimeRequirement() {
        if (!this.deliveryTimeRequirementIsViolate) {
            this.requestWaterSamplingAct.laboratoryDeliveryTimeRequirementDescription = null;
        }
    }

    changeSamplePreserve() {
        if (!this.samplePreserveIsManualPreserve) {
            this.requestWaterSamplingAct.laboratorySamplePreserveDescription = null;
        }
    }

    openIndicatorsModal() {
        const dialogRef = this.dialogService.open({
            title: "Выбор определяемых показателей",
            content: CheckboxSelectorComponent,
            width: 540,
            height: 560
        });

        let dialog = <CheckboxSelectorComponent>dialogRef.content.instance;

        dialog.contentHeight = 480;
        dialog.items = this.indicators.map(x => {
            let checked = this.requestIndicators.some(i => i.laboratoryIndicatorId == x.laboratoryIndicatorId);
            return {
                id: x.laboratoryIndicatorId,
                name: x.name,
                disabled: checked,
                checked: checked
            } as CheckboxItem
        });

        dialog.onCancelEvent.subscribe(() => {
            dialogRef.close();
        });

        dialog.onContinueEvent.subscribe((indicatorIds: number[]) => {
            indicatorIds.forEach(id => {
                if (!this.requestIndicators.some(x => x.laboratoryIndicatorId == id)) {
                    this.requestIndicators.push({
                        laboratoryIndicatorId: id
                    } as LaboratoryRequestIndicatorDto);
                }
            });
            dialogRef.close();
        });
    }

    isEmpty(value: string) {
        return value == null || value.trim() == '';
    }

    deleteRequestIndicator(indicatorId: number) {
        this.requestIndicators = this.requestIndicators.filter(x => x.laboratoryIndicatorId != indicatorId);
    }

    getIndicatorName(indicatorId: number) {
        return this.indicators.find(x => x.laboratoryIndicatorId == indicatorId).name;
    }

    get dataLoaded(): boolean {
        return this.actLoaded && this.lookupsLoaded;
    }

    get clientInfoValid(): boolean {
        return !this.isEmpty(this.requestWaterSamplingAct.customerContact.fullName) &&
            !this.isEmpty(this.requestWaterSamplingAct.customerContact.phone) &&
            !this.isEmpty(this.requestWaterSamplingAct.customerAddress.cityName) &&
            !this.isEmpty(this.requestWaterSamplingAct.samplingAddress.cityName);
    }

    get examinationObjectValid(): boolean {
        let examinationObjectValid = this.requestWaterSamplingAct.laboratoryExaminationObjectId != null;
        if (this.examinationObjectIsOther) {
            examinationObjectValid = !this.isEmpty(this.requestWaterSamplingAct.laboratoryExaminationObjectDescription);
        }
        if (this.examinationObjectIsBottle) {
            examinationObjectValid = 
                this.requestWaterSamplingAct.manufactureDate != null &&
                !this.isEmpty(this.requestWaterSamplingAct.supplier) &&
                !this.isEmpty(this.requestWaterSamplingAct.partNumber);
        }

        return examinationObjectValid;
    }

    get materialSourceValid(): boolean {
        let materialSourceValid = 
            this.requestWaterSamplingAct.laboratoryMaterialSourceId != null ||
            this.examinationObjectIsBottle;
        if (this.materialSourceIsOther && !this.examinationObjectIsBottle) {
            materialSourceValid = !this.isEmpty(this.requestWaterSamplingAct.laboratoryMaterialSourceDescription);
        }

        return materialSourceValid;
    }

    get samplingPointValid(): boolean {
        let samplingPointValid = 
            this.requestWaterSamplingAct.laboratorySamplingPointId != null ||
            this.examinationObjectIsBottle;     
        if (this.samplingPointIsOther && !this.examinationObjectIsBottle) {
            samplingPointValid = !this.isEmpty(this.requestWaterSamplingAct.laboratorySamplingPointDescription);
        }
        return samplingPointValid;
    }

    get indicatorsValid(): boolean {
        let indicatorsValid = this.requestIndicators.length > 0;
        return indicatorsValid;
    }

    get examinationTargetValid(): boolean {
        return this.validWithDescription(
            this.requestWaterSamplingAct.laboratoryExaminationTargetId,
            this.requestWaterSamplingAct.laboratoryExaminationTargetDescription,
            this.examinationTargetIsOther);
    }

    get specialMarkValid(): boolean {
        return this.validWithDescription(
            this.requestWaterSamplingAct.laboratorySpecialMarkId,
            this.requestWaterSamplingAct.laboratorySpecialMarkDescription,
            this.specialMarkIsOther);
    }

    get samplingPerformerValid(): boolean {
        return this.validWithDescription(
                this.requestWaterSamplingAct.laboratorySamplingPerformerId,
                this.requestWaterSamplingAct.laboratorySamplingPerformerDescription,
                this.samplingPerformerIsOther) &&
            this.samplingPerformerDateTimeValid;
    }

    get samplingPerformerDateTimeValid(): boolean {
        const start = this.requestWaterSamplingAct.laboratorySamplingPerformerDateTimeStart;
        const end = this.requestWaterSamplingAct.laboratorySamplingPerformerDateTimeEnd;

        if (start == null || end == null) {
            return false;
        }

        return this.isSameCalendarDay(start, end) && end >= start;
    }

    get samplingPerformerDateTimeEndInvalid(): boolean {
        const start = this.requestWaterSamplingAct.laboratorySamplingPerformerDateTimeStart;
        const end = this.requestWaterSamplingAct.laboratorySamplingPerformerDateTimeEnd;

        if (start == null || end == null) {
            return end == null;
        }

        return !this.isSameCalendarDay(start, end) || end < start;
    }

    get samplingPerformerDateTimeEndError(): string {
        const start = this.requestWaterSamplingAct.laboratorySamplingPerformerDateTimeStart;
        const end = this.requestWaterSamplingAct.laboratorySamplingPerformerDateTimeEnd;

        if (end == null) {
            return 'Укажите дату и время завершения отбора';
        }

        if (start != null && !this.isSameCalendarDay(start, end)) {
            return 'Отбор должен быть в один календарный день';
        }

        if (start != null && end < start) {
            return 'Время завершения не может быть раньше времени начала';
        }

        return null;
    }

    private isSameCalendarDay(start: Date, end: Date): boolean {
        return start.getFullYear() === end.getFullYear()
            && start.getMonth() === end.getMonth()
            && start.getDate() === end.getDate();
    }

    get sampleDeliveryPerformerValid(): boolean {
        return this.validWithDescription(
                this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerId,
                this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerDescription,
                this.sampleDeliveryPerformerIsOther) &&
            !this.isEmpty(this.requestWaterSamplingAct.laboratorySamplingPerformerName);
    }

    get sampleLeftoverActionValid(): boolean {
        return this.validWithDescription(
                this.requestWaterSamplingAct.laboratorySampleLeftoverActionId,
                this.requestWaterSamplingAct.laboratorySampleLeftoverActionDescription,
                this.sampleLeftoverActionIsOther) &&
            !this.isEmpty(this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerName) &&
            this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerDateTime != null;
    }

    get sampleContainerVisualDamageValid(): boolean {
        return this.validWithDescription(
            this.requestWaterSamplingAct.laboratorySampleContainerVisualDamageId,
            this.requestWaterSamplingAct.laboratorySampleContainerVisualDamageDescription,
            this.sampleContainerVisualDamageIsDetected);
    }

    get sampleContainerRequirementValid(): boolean {
        return this.validWithDescription(
            this.requestWaterSamplingAct.laboratorySampleContainerRequirementId,
            this.requestWaterSamplingAct.laboratorySampleContainerRequirementDescription,
            this.sampleContainerRequirementIsViolate);
    }

    get deliveryTimeRequirementValid(): boolean {
        return this.validWithDescription(
            this.requestWaterSamplingAct.laboratoryDeliveryTimeRequirementId,
            this.requestWaterSamplingAct.laboratoryDeliveryTimeRequirementDescription,
            this.deliveryTimeRequirementIsViolate);
    }

    get samplePreserveValid(): boolean {
        return this.validWithDescription(
            this.requestWaterSamplingAct.laboratorySamplePreserveId,
            this.requestWaterSamplingAct.laboratorySamplePreserveDescription,
            this.samplePreserveIsManualPreserve);
    }

    get samplingMethodValid(): boolean {
        return this.validWithDescription(
            this.requestWaterSamplingAct.laboratoryWaterSamplingMethodId,
            this.requestWaterSamplingAct.laboratoryWaterSamplingMethodDescription,
            this.samplingMethodIsOther) &&
            (!this.showWaterTapPreRinsing || this.requestWaterSamplingAct.waterTapPreRinsing != null);
    }

    get samplingConditionValid(): boolean {
        return this.validWithDescription(
            this.requestWaterSamplingAct.laboratoryWaterSamplingConditionId,
            this.requestWaterSamplingAct.laboratoryWaterSamplingConditionDescription,
            this.samplingConditionIsOther);
    }

    get regulatoryDocumentValid(): boolean {
        let ids = this.requestWaterSamplingAct.laboratoryWaterSamplingRegulatoryDocumentIds;
        if (ids == null) {
            ids = [];
        }
        if (ids.length === 0) {
            return false;
        }
        if (this.regulatoryDocumentIsOther && this.isEmpty(this.requestWaterSamplingAct.laboratoryWaterSamplingRegulatoryDocumentDescription)) {
            return false;
        }
        return true;
    }

    private validWithDescription(id: number, description: string, checkDescription: boolean) {
        let valid = id != null;
        if (checkDescription) {
            valid = !this.isEmpty(description);
        }
        return valid;
    }

    get canSave(): boolean {
        let sampleCollectionValid = this.requestCategoryId != <number>RequestCategoryEnum.sampleCollectionBySpecialist ||
            (this.samplePreserveValid && this.samplingConditionValid && this.regulatoryDocumentValid);

        return this.examinationObjectValid &&
            this.materialSourceValid &&
            this.samplingPointValid &&
            this.indicatorsValid &&
            this.examinationTargetValid &&
            this.specialMarkValid &&
            this.samplingPerformerValid &&
            this.sampleDeliveryPerformerValid &&
            this.sampleLeftoverActionValid &&
            this.sampleContainerVisualDamageValid &&
            this.sampleContainerRequirementValid &&
            this.deliveryTimeRequirementValid &&
            this.samplePreserveValid &&
            sampleCollectionValid &&
            this.requestWaterSamplingAct.laboratoryCertificateRequiringId != null &&
            this.requestWaterSamplingAct.laboratoryResultDeliveryTypeId != null &&
            this.requestWaterSamplingAct.laboratoryRecommendationId != null &&
            this.requestWaterSamplingAct.laboratorySampleContainerTypeId != null;
    }

    get examinationObjectIsBottle(): boolean {
        return this.examinationObjectHasCode(this.bottleCode);
    }

    get examinationObjectIsOther(): boolean {
        return this.examinationObjectHasCode(this.otherCode);
    }

    private examinationObjectHasCode(searchingCode: string) {
        if (this.requestWaterSamplingAct.laboratoryExaminationObjectId) {
            let code = this.examinationObjects.find(x => 
                x.laboratoryExaminationObjectId == this.requestWaterSamplingAct.laboratoryExaminationObjectId).code;
            return code == searchingCode;
        }
        
        return false;
    }

    get materialSourceIsOther(): boolean {
        if (this.requestWaterSamplingAct.laboratoryMaterialSourceId) {
            let code = this.materialSources.find(x => 
                x.laboratoryMaterialSourceId == this.requestWaterSamplingAct.laboratoryMaterialSourceId).code;
            return code == this.otherCode;
        }
        
        return false;
    }

    get samplingPointIsOther(): boolean {
        if (this.requestWaterSamplingAct.laboratorySamplingPointId) {
            let code = this.samplingPoints.find(x => 
                x.laboratorySamplingPointId == this.requestWaterSamplingAct.laboratorySamplingPointId).code;
            return code == this.otherCode;
        }
        
        return false;
    }

    get samplingMethodIsOther(): boolean {
        if (this.requestWaterSamplingAct.laboratoryWaterSamplingMethodId) {
            let code = this.samplingMethods.find(x =>
                x.laboratoryWaterSamplingMethodId == this.requestWaterSamplingAct.laboratoryWaterSamplingMethodId).code;
            return code == this.otherCode;
        }

        return false;
    }

    get regulatoryDocumentIsOther(): boolean {
        let ids = this.requestWaterSamplingAct.laboratoryWaterSamplingRegulatoryDocumentIds;
        if (ids == null) {
            ids = [];
        }
        return ids.some(id => {
            const doc = this.regulatoryDocuments.find(x => x.laboratoryWaterSamplingRegulatoryDocumentId === id);
            return doc != null && doc.code === this.otherCode;
        });
    }

    get samplingConditionIsOther(): boolean {
        if (this.requestWaterSamplingAct.laboratoryWaterSamplingConditionId) {
            let code = this.samplingConditions.find(x =>
                x.laboratoryWaterSamplingConditionId == this.requestWaterSamplingAct.laboratoryWaterSamplingConditionId).code;
            return code == this.otherCode;
        }

        return false;
    }

    get examinationTargetIsOther(): boolean {
        if (this.requestWaterSamplingAct.laboratoryExaminationTargetId) {
            let code = this.examinationTargets.find(x => 
                x.laboratoryExaminationTargetId == this.requestWaterSamplingAct.laboratoryExaminationTargetId).code;
            return code == this.otherCode;
        }
        
        return false;
    }

    get specialMarkIsOther(): boolean {
        if (this.requestWaterSamplingAct.laboratorySpecialMarkId) {
            let code = this.specialMarks.find(x => 
                x.laboratorySpecialMarkId == this.requestWaterSamplingAct.laboratorySpecialMarkId).code;
            return code == this.otherCode;
        }
        
        return false;
    }

    get samplingPerformerIsOther(): boolean {
        return this.samplingPerformerHasCode(this.otherCode);
    }

    get samplingPerformerIsContragent(): boolean {
        return this.samplingPerformerHasCode(this.contragentCode);
    }

    get samplingPerformerIsBarier(): boolean {
        return this.samplingPerformerHasCode(this.barierCode);
    }

    samplingPerformerHasCode(searchCode: string) {
        if (this.requestWaterSamplingAct.laboratorySamplingPerformerId) {
            let code = this.samplingPerformers.find(x =>
                x.laboratorySamplingPerformerId == this.requestWaterSamplingAct.laboratorySamplingPerformerId).code;
            return code == searchCode;
        }

        return false;
    }

    get sampleDeliveryPerformerIsOther(): boolean {
        return this.sampleDeliveryPerformerHasCode(this.otherCode);
    }

    get sampleDeliveryPerformerIsContragent(): boolean {
        return this.sampleDeliveryPerformerHasCode(this.contragentCode);
    }

    get sampleDeliveryPerformerIsBarier(): boolean {
        return this.sampleDeliveryPerformerHasCode(this.barierCode);
    }

    sampleDeliveryPerformerHasCode(searchCode: string): boolean {
        if (this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerId) {
            let code = this.sampleDeliveryPerformers.find(x =>
                x.laboratorySampleDeliveryPerformerId == this.requestWaterSamplingAct.laboratorySampleDeliveryPerformerId).code;
            return code == searchCode;
        }

        return false;
    }

    get sampleLeftoverActionIsOther(): boolean {
        if (this.requestWaterSamplingAct.laboratorySampleLeftoverActionId) {
            let code = this.sampleLeftoverActions.find(x =>
                x.laboratorySampleLeftoverActionId == this.requestWaterSamplingAct.laboratorySampleLeftoverActionId).code;
            return code == this.otherCode;
        }

        return false;
    }

    get sampleContainerVisualDamageIsDetected(): boolean {
        if (this.requestWaterSamplingAct.laboratorySampleContainerVisualDamageId) {
            let code = this.sampleContainerVisualDamages.find(x =>
                x.laboratorySampleContainerVisualDamageId == this.requestWaterSamplingAct.laboratorySampleContainerVisualDamageId).code;
            return code == this.detectedCode;
        }

        return false;
    }

    get sampleContainerRequirementIsViolate(): boolean {
        if (this.requestWaterSamplingAct.laboratorySampleContainerRequirementId) {
            let code = this.sampleContainerRequirements.find(x =>
                x.laboratorySampleContainerRequirementId == this.requestWaterSamplingAct.laboratorySampleContainerRequirementId).code;
            return code == this.violateCode;
        }

        return false;
    }

    get deliveryTimeRequirementIsViolate(): boolean {
        if (this.requestWaterSamplingAct.laboratoryDeliveryTimeRequirementId) {
            let code = this.deliveryTimeRequirements.find(x =>
                x.laboratoryDeliveryTimeRequirementId == this.requestWaterSamplingAct.laboratoryDeliveryTimeRequirementId).code;
            return code == this.violateCode;
        }

        return false;
    }

    get samplePreserveIsManualPreserve(): boolean {
        if (this.requestWaterSamplingAct.laboratorySamplePreserveId) {
            let code = this.samplePreserves.find(x =>
                x.laboratorySamplePreserveId == this.requestWaterSamplingAct.laboratorySamplePreserveId).code;
            return code == this.manualPreserveCode;
        }

        return false;
    }
}